"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("rxjs/add/operator/map");
require("rxjs/add/operator/map");
require("rxjs/add/operator/scan");
require("rxjs/add/operator/concat");
require("rxjs/add/operator/catch");
require("rxjs/add/operator/share");
require("rxjs/add/operator/merge");
require("rxjs/add/operator/mergeMap");
require("rxjs/add/operator/filter");
require("rxjs/add/operator/reduce");
require("rxjs/add/operator/switchMap");
require("rxjs/add/operator/startWith");
require("rxjs/add/operator/takeUntil");
require("rxjs/add/operator/combineLatest");
require("rxjs/add/operator/withLatestFrom");
require("rxjs/add/operator/subscribeOn");
require("rxjs/add/operator/distinctUntilChanged");
require("rxjs/add/operator/publishReplay");
require("rxjs/add/operator/publish");
require("rxjs/add/operator/throttleTime");
require("rxjs/add/operator/debounceTime");
require("rxjs/add/operator/shareReplay");
require("rxjs/add/operator/do");
require("rxjs/add/operator/ignoreElements");
require("rxjs/add/operator/mapTo");
require("rxjs/add/operator/switchMapTo");
require("rxjs/add/operator/find");
require("rxjs/add/operator/take");
require("rxjs/add/operator/takeWhile");
require("rxjs/add/operator/delay");
require("rxjs/add/operator/last");
require("rxjs/add/observable/of");
require("rxjs/add/operator/multicast");
require("rxjs/add/operator/observeOn");
require("rxjs/add/operator/pairwise");
var rxjs_1 = require("rxjs");
var Option_1 = require("fp-ts/lib/Option");
function toKeyValue(key) {
    return this.map(function (value) {
        var _a;
        return (_a = {},
            _a[key] = value,
            _a);
    });
}
exports.toKeyValue = toKeyValue;
rxjs_1.Observable.prototype['toKeyValue'] = toKeyValue;
function select(selector) {
    return this.map(selector).distinctUntilChanged();
}
exports.select = select;
rxjs_1.Observable.prototype['select'] = select;
function filterOption() {
    return this.filter(Option_1.isSome).map(function (option) { return option.value; });
}
exports.filterOption = filterOption;
rxjs_1.Observable.prototype['filterOption'] = filterOption;
function log() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    // tslint:disable-next-line:no-console
    this.subscribe(function (arg) { return console.log.apply(console, args.concat([arg])); });
}
exports.log = log;
rxjs_1.Observable.prototype['log'] = log;
